import React, { useState, useRef, useEffect } from "react";
import { Modal } from "reactstrap";
import { connect } from "react-redux";
import { closeInteractivityModal } from "../../redux/modal/action";
import { iconsObj, sendAnalyticsEvent } from "../../helper/utility";
import ModalBody from "reactstrap/lib/ModalBody";
import Row from "reactstrap/lib/Row";
import { isIOS } from "react-device-detect";
import Close from "../../assets/images/icons/close.svg";
import ContentModal from "./modalbody/ContentModal";
import Marker from "../leaflet/markers/Marker";
import { serverResponse } from "../../util/fakeServer";
import { gaEventLabel } from "../../settings/gaConfig";
import ManagerFactory from "../../managers/ManagerFactory";
import LoaderModal from "../common/LoaderModal";
import ModalFooter from "reactstrap/lib/ModalFooter";
import useCurrentWidth from "../../hooks/widthHook";
import { BREAKPOINT } from "../../helper/constant";
import { styles } from "./header.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookSquare,
  // faInstagramSquare,
  // faTwitterSquare,
  faWhatsappSquare,
} from "@fortawesome/free-brands-svg-icons";
import ContentModalMobile from "./modalbody/ContentModalMobile";

const manager = ManagerFactory.getManager();

const ModalComponent = (props) => {
  const otherPropsModal = props.modalRedux.otherProps;
  const fakeServerConfig = props.fakeServer.config;
  const productUrl = serverResponse.config.shareFlyerURL;

  const [actTab, setActTab] = useState("plus");
  const [itemId, setItemId] = useState();
  const width = useCurrentWidth();

  const [scrolling, setScrolling] = useState(false);

  // Ref per il container del menu mobile delle interattività
  const mobileMenuRef = useRef(null);

  // Auto-scroll del menu per mantenere l'elemento attivo sempre visibile
  useEffect(() => {
    if (mobileMenuRef.current && width <= BREAKPOINT.xs) {
      const activeButton = mobileMenuRef.current.querySelector('.active');
      if (activeButton) {
        activeButton.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }
  }, [actTab, width]);

  const scrollToSlide = (id) => {
    const element = document.getElementById(id);
    if (element && !scrolling) {
      setScrolling(true);
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Use setTimeout based on scroll duration to manage when scrolling is complete
      setTimeout(() => {
        setScrolling(false); // Reset scrolling flag
      }, 800); // Adjust the duration as needed to match your scroll animation time
    }
  };

  const { contentModal: info } = props.modalRedux;

  const shareOnFacebook = () => {
    sendAnalyticsEvent(
      gaEventLabel.share_product_facebook,
      String(otherPropsModal.info.item_id)
    );

    let fb_share_url = "https://www.facebook.com/share.php?u=";
    let page_url =
      productUrl + "/share/product.php?c=" + otherPropsModal.info.item_id;
    window.open(
      fb_share_url + encodeURIComponent(page_url),
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    );
  };

  const shareOnWhatsapp = () => {
    sendAnalyticsEvent(
      gaEventLabel.share_product_whatsapp,
      String(otherPropsModal.info.item_id)
    );

    let page_url =
      productUrl + "/share/product.php?c=" + otherPropsModal.info.item_id;
    if (window.ReactNativeWebView !== undefined && isIOS) {
      let link = encodeURIComponent(page_url);
      let title = serverResponse.config.shareProductSentence;
      var str = title + " " + link;
      var obj = { action: "whatsapp", value: str };
      window.ReactNativeWebView.postMessage(JSON.stringify(obj));
    } else {
      window.open(
        "http://api.whatsapp.com/send?text=" +
          serverResponse.config.shareProductSentence +
          " " +
          encodeURIComponent(page_url),
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );
    }
  };

  const title_type = manager.getTitleType();

  const activedInteractivities = !props.modalRedux.loading
    ? otherPropsModal.info.markers.map((el) => el.type)
    : [];

  // Tab effettivamente da renderizzare nel footer: intersezione tra title_type
  // (i tipi marker configurati globalmente in DashboardLayout) e i marker
  // realmente presenti su QUESTO prodotto. Se il prodotto ha solo "plus"
  // (Dettaglio), activeTabKeys ha length 1 → footer nascosto. Se ha più
  // marker, mostra solo i tab di quei marker (niente più tab greyed di tipi
  // appartenenti ad ALTRI prodotti del volantino).
  const activeTabKeys = Object.keys(title_type).filter((el) =>
    activedInteractivities.includes(el)
  );

  // const space = width <= BREAKPOINT.xs ? "102px" : "92px";

  return (
    <Modal
      className={`main-modal custom-bs-modal ${props.className} ${
        info.related &&
        info.related.length > 0 &&
        otherPropsModal.type === "plus"
          ? "has-related-products"
          : ""
      }`}
      // style={{ height: isMobile ? "95vh" : "inherit" }}
      centered
      isOpen={props.modalRedux.isModalOpen}
      toggle={() => {
        props.closeInteractivityModal();
      }}
      size="xl"
      onOpened={() => {
        // props.isModalOpen(true);
        if (otherPropsModal.disableSwipe !== undefined)
          otherPropsModal.disableSwipe();
      }}
      onClosed={() => {
        // this.props.isModalOpen(false);
        if (otherPropsModal.enableSwipe !== undefined)
          otherPropsModal.enableSwipe();
      }}
    >
      <div className="row h-sm-100">
        <div
          className={`col-12 modal-header-cs ${
            fakeServerConfig.hide_share_product && "text-right"
          }`}
        >
          <div className="modal-header-wrap asas">
            {!fakeServerConfig.hide_share_product && (
              <div style={styles.style_container_header}>
                <div style={styles.socialIcons}>
                  {/* <div className="social-icon">
                      <FontAwesomeIcon icon={faInstagramSquare} />
                    </div> */}
                  <div
                    className="social-icon"
                    onClick={() => shareOnFacebook()}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </div>
                  {/* <div className="social-icon">
                      <FontAwesomeIcon icon={faTwitterSquare} />
                    </div> */}
                  <div
                    className="social-icon"
                    onClick={() => shareOnWhatsapp()}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={faWhatsappSquare} />
                  </div>
                </div>
                {manager.closeButtonIcon() ? (
                  <FontAwesomeIcon
                    onClick={() => props.closeInteractivityModal()}
                    icon={faTimes}
                    color="#0D0040"
                    size="lg"
                    className="cursor-pointer"
                  />
                ) : (
                  <span
                    onClick={() => props.closeInteractivityModal()}
                    style={{ cursor: "pointer" }}
                  >
                    Torna al catalogo
                  </span>
                )}
              </div>
            )}
            {fakeServerConfig.hide_share_product && (
              <FontAwesomeIcon
                onClick={() => props.closeInteractivityModal()}
                icon={faTimes}
                color="#0D0040"
                size="lg"
                className="cursor-pointer ml-auto d-block"
              />
            )}
            {/* <hr className="my-0" style={styles.hr_style} /> */}
          </div>
        </div>
        {width <= BREAKPOINT.xs && (
          <div className="col-12 modal-footer-cs productdetails-footer">
            {activeTabKeys.length > 1 &&
              props.modalRedux.isProduct && (
                <div
                  ref={mobileMenuRef}
                  style={{
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch',
                  }}
                >
                <ModalFooter
                  style={{
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    padding: 0,
                  }}
                >
                  {activeTabKeys.map((el, index) => {
                    const isActive = actTab === el;
                    return (
                      <React.Fragment key={`${el}_${index}`}>
                        <button
                          onClick={() => {
                            setActTab(el);
                            scrollToSlide(el);
                          }}
                          style={{
                            // Layout A — mobile: content-sized + scroll
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            padding: "14px 18px",
                            fontSize: "1rem",
                            fontWeight: isActive ? 700 : 500,
                            color: isActive
                              ? "var(--primary-color)"
                              : "#4B5563",
                            background: "transparent",
                            border: "none",
                            borderBottom: `3px solid ${
                              isActive ? "var(--primary-color)" : "transparent"
                            }`,
                            borderRadius: 0,
                            cursor: "pointer",
                            transition: "color 0.15s, border-color 0.15s",
                            whiteSpace: "nowrap",
                            flex: "0 0 auto",
                            scrollSnapAlign: "start",
                          }}
                          className={`m-0 btn custom_inter overlay tab-layout-a ${
                            isActive ? "active" : ""
                          }`}
                        >
                          {/* Icona PRIMA del testo (Layout A) */}
                          {isActive ? (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                color: "inherit",
                              }}
                            >
                              {iconsObj[el].component}
                            </div>
                          ) : (
                            otherPropsModal &&
                            !props.modalRedux.loading && (
                              <Marker
                                from_leaflet={false}
                                dynamic_price={
                                  props.modalRedux.otherProps.dynamic_price
                                }
                                dynamic_info={
                                  props.modalRedux.otherProps.dynamic_info
                                }
                                show_dynamic_price={
                                  props.modalRedux.otherProps.show_dynamic_price
                                }
                                zoom={otherPropsModal.zoom}
                                disableSwipe={otherPropsModal.disableSwipe}
                                enableSwipe={otherPropsModal.enableSwipe}
                                key={index}
                                info={otherPropsModal.info}
                                markerInfo={
                                  otherPropsModal.info.markers.filter(
                                    (info) => info.type === el
                                  )[0]
                                }
                                leafletSwipe={otherPropsModal.leafletSwipe}
                                navMarkers={otherPropsModal.navMarkers}
                                setSwipe={otherPropsModal.setSwipe}
                                isSwipeDisabed={otherPropsModal.isSwipeDisabed}
                                type={el}
                                custom_class={"custom_width_marker"}
                                />
                              )
                            )}
                          {/* Label DOPO l'icona (Layout A) */}
                          <span style={{ color: "inherit" }}>
                            {title_type[el]}
                          </span>
                          </button>
                        </React.Fragment>
                      );
                    })}
                </ModalFooter>
                </div>
              )}
          </div>
        )}
        <div className="col-12 modal-body-cs my-5">
          <ModalBody
            className="d-md-flex align-items-center overflowhidden"
            // style={{ height: "calc(100% - 50px)" }}
            // style={{
            //   height: `calc(${
            //     width >= BREAKPOINT.xs ? "80vh" : "90vh"
            //   } - ${space})`,
            // }}
          >
            {props.modalRedux.loading ? (
              <Row>
                <LoaderModal width="50vw" height="50vh" />
              </Row>
            ) : null}
            {/* CONTENUTO DINAMICO MODALE */}

            {!props.modalRedux.loading && (
              <>
                <div
                  className={`xs-h-auto modal-innerBlock modal-content-main-wrap ${
                    width >= BREAKPOINT.xs ? "w-100" : ""
                  } ${
                    otherPropsModal.type === "play" ? "w-100 m-0" : ""
                  }  ${manager.getRowClass(props.modalRedux.otherProps.type)}`}
                >
                  {width <= BREAKPOINT.xs ? (
                    <>
                      <ContentModalMobile
                        activeTab={actTab}
                        setActiveTab={setActTab}
                        scrolling={scrolling}
                      />
                    </>
                  ) : (
                    <ContentModal {...props.modalRedux.otherProps} />
                  )}
                </div>
              </>
            )}
          </ModalBody>
        </div>
        <div className="col-12 modal-footer-cs d-none d-sm-block">
          <div className="modal-footer-wrap-cs">
            {activeTabKeys.length > 1 &&
              props.modalRedux.isProduct && (
                <ModalFooter
                  style={{
                    justifyContent: "stretch",
                    flexWrap: "nowrap",
                    padding: 0,
                  }}
                >
                  {activeTabKeys.map((el, index) => {
                    const isActive = otherPropsModal.type === el;
                    return (
                      <React.Fragment key={`${el}_${index}`}>
                        <button
                          onClick={() => {
                            if (
                              document.getElementById(
                                `${el}-${otherPropsModal.info.item_id}`
                              )
                            )
                              document
                                .getElementById(
                                  `${el}-${otherPropsModal.info.item_id}`
                                )
                                .click();
                            setItemId(otherPropsModal.info.item_id);
                          }}
                          style={{
                            // Layout A — underline tabs (Material/Tailwind)
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            width: `calc(100% / ${activeTabKeys.length})`,
                            padding: "14px 18px",
                            fontSize: "1rem",
                            fontWeight: isActive ? 700 : 500,
                            color: isActive
                              ? "var(--primary-color)"
                              : "#4B5563",
                            background: "transparent",
                            border: "none",
                            borderBottom: `3px solid ${
                              isActive ? "var(--primary-color)" : "transparent"
                            }`,
                            borderRadius: 0,
                            cursor: "pointer",
                            transition: "color 0.15s, border-color 0.15s",
                            whiteSpace: "nowrap",
                            minWidth: 0,
                          }}
                          className={`m-0 btn custom_inter overlay tab-layout-a ${
                            isActive ? "active" : ""
                          }`}
                        >
                          {/* Icona PRIMA del testo (Layout A) */}
                          {isActive ? (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                color: "inherit",
                              }}
                            >
                              {iconsObj[el].component}
                            </div>
                          ) : (
                            otherPropsModal &&
                            !props.modalRedux.loading && (
                              <Marker
                                from_leaflet={false}
                                dynamic_price={
                                  props.modalRedux.otherProps.dynamic_price
                                }
                                dynamic_info={
                                  props.modalRedux.otherProps.dynamic_info
                                }
                                show_dynamic_price={
                                  props.modalRedux.otherProps.show_dynamic_price
                                }
                                zoom={otherPropsModal.zoom}
                                disableSwipe={otherPropsModal.disableSwipe}
                                enableSwipe={otherPropsModal.enableSwipe}
                                key={index}
                                info={otherPropsModal.info}
                                markerInfo={
                                  otherPropsModal.info.markers.filter(
                                    (info) => info.type === el
                                  )[0]
                                }
                                leafletSwipe={otherPropsModal.leafletSwipe}
                                navMarkers={otherPropsModal.navMarkers}
                                setSwipe={otherPropsModal.setSwipe}
                                isSwipeDisabed={otherPropsModal.isSwipeDisabed}
                                type={el}
                                custom_class={"custom_width_marker"}
                              />
                            )
                          )}
                          {/* Label DOPO l'icona */}
                          <span style={{ color: "inherit" }}>
                            {title_type[el]}
                          </span>
                        </button>
                      </React.Fragment>
                    );
                  })}
                </ModalFooter>
              )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal,
    fakeServer: state.fakeServer,
  };
};

export default connect(mapStateToProps, {
  closeInteractivityModal,
})(ModalComponent);
